import { render, staticRenderFns } from "./AddSliderModal.vue?vue&type=template&id=3df7e6e6&scoped=true&"
import script from "./AddSliderModal.vue?vue&type=script&lang=js&"
export * from "./AddSliderModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSliderModal.vue?vue&type=style&index=0&id=3df7e6e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df7e6e6",
  null
  
)

export default component.exports